// DescriptionBlock — small section that renders the property's free-
// text description with a mono-uppercase header. Same shape on both
// detail surfaces; callers gate visibility (we don't render when the
// description is missing or whitespace-only).

interface DescriptionBlockProps {
  description: string;
}

export function DescriptionBlock({ description }: DescriptionBlockProps) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="font-mono text-[11px] tracking-widest text-ink-faint uppercase">
        Mô tả
      </h2>
      <p className="text-[14px] leading-relaxed whitespace-pre-line text-ink-soft">
        {description}
      </p>
    </section>
  );
}
